import type { ChatState, ChatAction } from '../types';

export function chatReducer(state: ChatState, action: ChatAction): ChatState {
  switch (action.type) {
    case 'SET_MESSAGES':
      return { ...state, messages: action.messages };
    case 'ADD_MESSAGE':
      return { ...state, messages: [...state.messages, action.message] };
    case 'SET_INPUT':
      return { ...state, input: action.input };
    case 'SEND_START':
      return { ...state, loading: true, error: '', isTyping: true };
    case 'SEND_SUCCESS':
      return { ...state, loading: false, isTyping: false };
    case 'SEND_ERROR':
      return { ...state, loading: false, isTyping: false, error: action.error };
    case 'SET_TYPING':
      return { ...state, isTyping: action.isTyping };
    case 'SET_STREAMING':
      return { ...state, streamingMessage: action.message };
    case 'UPDATE_STREAMING':
      if (!state.streamingMessage) return state;
      return { ...state, streamingMessage: { ...state.streamingMessage, text: action.text } };
    case 'ADD_TOOL_CALL':
      return { ...state, activeToolCalls: [...state.activeToolCalls, action.toolCall] };
    case 'UPDATE_TOOL_CALLS':
      return { ...state, activeToolCalls: action.toolCalls };
    case 'CLEAR_STREAMING':
      return { ...state, streamingMessage: null, activeToolCalls: [] };
    case 'CLEAR_ERROR':
      return { ...state, error: '' };
    default:
      return state;
  }
}

export const initialChatState: ChatState = {
  messages: [],
  input: '',
  loading: false,
  error: '',
  isTyping: false,
  streamingMessage: null,
  activeToolCalls: [],
};
